import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useState } from "react";
import CommonForm from "../../../components/form/form";
import {
  createBranch,
  deleteBranch,
  getBranchList,
  updateBranch,
} from "../../../../services/workspace/branch.service";
import {
  createDataTransformer,
  presetTransformers,
} from "../../../../utils/dataTransformers";
import {
  createActionButtons,
  commonConditions,
} from "../../../../utils/actionButtonHelpers";

const actions_type = {
  DELETE: "DELETE",
  ADD_EDIT: "ADD_EDIT",
};

const items = [{ label: "Branch Management", path: "" }];

const ManageBranch = () => {
  const [isEditValue, setIsEditValue] = useState(null);

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    sortingUIProps,
  } = useCommonFetch(getBranchList, {
    dataPath: "branch.data",
    totalPath: "branch.meta.total",
    errorMessage: "Failed to fetch branch data!",
    debounceDelay: 500,
    sortingOptions: [
      { label: "Name", field: "name" },
      { label: "Date", field: "created_at" },
    ],
    sortingModule: "branch",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
          },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,
    dataTransformer: createDataTransformer(
      presetTransformers.basicEntity(null, "uuid"),
      () =>
        createActionButtons({
          delete: {
            handler: (item) => {
              handleDelete(item.id.data, deleteBranch, {
                successMessage: "Branch deleted successfully!",
                errorMessage: "Failed to delete branch!",
            });
            },
            show: commonConditions.always,
          },
          edit: {
            handler: (item) => {
            openModal(item, actions_type.ADD_EDIT);
            const InitialData = {
              id: item.id.data,
              name: item?.name.data,
                address: item.address?.data || "",
                contact: item.contact?.data || "",
                email: item.email?.data || "",
                description: item.description?.data || "",
            };
            setIsEditValue(InitialData);
          },
            show: commonConditions.always,
    },
        })
    ),
  });

  const TableHeaderData = [
    {
      label: "Branch Name",
      key: "name",
    },
    {
      label: "Address",
      key: "address",
    },
    {
      label: "Contact",
      key: "contact",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Description",
      key: "description",
    },
    {
      label: "Created At",
      key: "created_at",
    },
  ];

  // Comprehensive form fields
  const comprehensiveFields = [
    {
      name: "name",
      label: "Branch Name",
      type: "text",
      placeholder: "Enter branch name",
      required: true,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "address",
      label: "Address",
      type: "textarea",
      placeholder: "Enter branch address",
      required: false,
      maxLength: 500,
    },
    {
      name: "contact",
      label: "Contact Number",
      type: "text",
      placeholder: "Enter contact number",
      required: false,
      maxLength: 20,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      placeholder: "Enter email address",
      required: false,
      maxLength: 100,
    },
    {
      name: "description",
      label: "Description",
      type: "textarea",
      placeholder: "Write description here...",
      required: false,
      maxLength: 300,
    },
  ];

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    // Edit
    if (isEditValue) {
      const response = await handleUpdate(
        values,
        isEditValue.id,
        updateBranch,
        {
          successMessage: "Branch updated successfully!",
          errorMessage: "Failed to update branch!",
        }
      );
      if (response?.success) {
        setIsEditValue(null);
        closeModal();
      }
    } else {
      // Create new
      const response = await handleCreate(values, createBranch, {
        successMessage: "Branch created successfully!",
        errorMessage: "Failed to create branch!",
      });
      if (response?.success) {
        closeModal();
      }
    }

    setSubmitting(false);
    setTimeout(() => {
      resetForm();
      setIsEditValue(null);
    }, 1000);
  };

  // Handle form cancellation
  const handleCancel = () => {
      setIsEditValue(null);
      closeModal();
  };

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        onClickAdd={() => openModal("", actions_type.ADD_EDIT)}
        shorting
        sortingModule="branch"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
      />

      <div className={"flex flex-col gap-2"}>
        <CommonTable
          search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
          showActions={true}
        />

        {action === actions_type.ADD_EDIT && (
          <CommonModal
            modalSize="lg"
            headerTitle={selectedId ? "Edit Branch" : "Add Branch"}
            onClose={handleCancel}
            show={action === actions_type.ADD_EDIT}
          >
            {/* Form */}
            <CommonForm
              fields={comprehensiveFields}
              initialData={isEditValue ? isEditValue : {}}
              onSubmit={handleSubmit}
              submitButtonText={"Submit"}
              onCancel={handleCancel}
              cancelButtonText="Cancel"
              columnsPerRow={1}
              gap="gap-4"
              rowClassName="   "
              fieldClassName="bg-white p-3 rounded shadow-sm"
            />
          </CommonModal>
        )}
      </div>
    </div>
  );
};
export default ManageBranch;
